import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import styles from './QuickActionsSection.module.css';

const quickActions = [
  {
    label: 'New Analysis',
    icon: 'pi pi-plus',
    subtitle: 'Start gap analysis',
    route: '/analyses/create',
    color: '#377dff',
    enabled: true
  },
  {
    label: 'Document Library',
    icon: 'pi pi-folder',
    subtitle: 'Browse documents',
    route: '/documents',
    color: '#14692a',
    enabled: true
  },
  {
    label: 'All Analyses',
    icon: 'pi pi-chart-bar',
    subtitle: 'View all analyses',
    route: '/analyses',
    color: '#f59e0b',
    enabled: true
  },
  {
    label: 'Export Results',
    icon: 'pi pi-download',
    subtitle: 'Download reports',
    route: '/export',
    color: '#6366f1',
    enabled: false
  }
];

export const QuickActionsSection = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.quickActionsSection}>
      <h2 className={styles.sectionTitle}>
        <i className="pi pi-bolt" style={{ marginRight: '10px' }}></i>
        Quick Actions
      </h2>
      <div className={styles.actionsGrid}>
        {quickActions.map((action) => (
          <Card
            key={action.label}
            className={`${styles.actionCard} ${!action.enabled ? styles.disabled : ''}`}
            onClick={() => action.enabled && navigate(action.route)}
          >
            <div className={styles.actionCardContent}>
              <div
                className={styles.actionIcon}
                style={{ backgroundColor: action.color }}
              >
                <i className={action.icon}></i>
              </div>
              <div className={styles.actionLabel}>{action.label}</div>
              <div className={styles.actionSubtitle}>{action.subtitle}</div>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
};
